import { diffLines } from 'diff'

// Prompts passam de 30k chars. Sem colapsar os trechos iguais, o diff vira um
// muro de texto identico onde ninguem acha a mudanca.
export const LINHAS_DE_CONTEXTO = 3

/**
 * Converte dois textos numa lista de blocos para render.
 * Cada bloco e UM dos dois formatos:
 *   { linhas: [{ tipo: 'igual'|'adicionada'|'removida', texto }] }
 *   { omitidas: n }   trecho sem alteracao, colapsado
 */
export function montarBlocos(anterior, atual) {
  const linhas = []
  for (const parte of diffLines(anterior ?? '', atual ?? '')) {
    const tipo = parte.added ? 'adicionada' : parte.removed ? 'removida' : 'igual'
    const texto = parte.value.split('\n')
    if (texto.at(-1) === '') texto.pop() // split deixa string vazia no fim
    for (const conteudo of texto) linhas.push({ tipo, texto: conteudo })
  }

  const blocos = []
  let blocoAtual = []
  let iguaisSeguidas = 0

  const despejar = () => {
    if (blocoAtual.length > 0) blocos.push({ linhas: blocoAtual })
    blocoAtual = []
  }

  for (let i = 0; i < linhas.length; i += 1) {
    const linha = linhas[i]
    if (linha.tipo !== 'igual') {
      blocoAtual.push(linha)
      iguaisSeguidas = 0
      continue
    }

    const mudancaPerto = linhas.slice(i, i + LINHAS_DE_CONTEXTO + 1).some((l) => l.tipo !== 'igual')
    const mudancaRecente = iguaisSeguidas < LINHAS_DE_CONTEXTO && blocos.length + blocoAtual.length > 0

    if (mudancaPerto || mudancaRecente) {
      blocoAtual.push(linha)
      iguaisSeguidas += 1
      continue
    }

    despejar()
    let omitidas = 0
    while (i < linhas.length && linhas[i].tipo === 'igual') {
      if (linhas.slice(i, i + LINHAS_DE_CONTEXTO + 1).some((l) => l.tipo !== 'igual')) break
      omitidas += 1
      i += 1
    }
    i -= 1
    if (omitidas > 0) blocos.push({ omitidas })
    iguaisSeguidas = 0
  }
  despejar()

  return blocos
}

/** Totais de linhas alteradas. Ignora blocos colapsados, que nao tem `linhas`. */
export function contarMudancas(blocos) {
  let adicionadas = 0
  let removidas = 0
  for (const bloco of blocos) {
    for (const linha of bloco.linhas ?? []) {
      if (linha.tipo === 'adicionada') adicionadas += 1
      if (linha.tipo === 'removida') removidas += 1
    }
  }
  return { adicionadas, removidas, identico: adicionadas === 0 && removidas === 0 }
}
